// FryaTry — scroll animations, countdown timer, floating WhatsApp button,
// product page sticky bar + quantity stepper

document.addEventListener('DOMContentLoaded', function () {

  // ---- Scroll-reveal animations ----
  var animEls = document.querySelectorAll('.frytry-animate');
  if ('IntersectionObserver' in window && animEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    animEls.forEach(function (el) { observer.observe(el); });
  } else {
    animEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---- Countdown timer(s) ----
  var timers = document.querySelectorAll('[data-frytry-countdown]');
  timers.forEach(function (timerEl) {
    var endTime = new Date(timerEl.getAttribute('data-frytry-countdown')).getTime();
    var daysEl = timerEl.querySelector('[data-cd-days]');
    var hoursEl = timerEl.querySelector('[data-cd-hours]');
    var minsEl = timerEl.querySelector('[data-cd-mins]');
    var secsEl = timerEl.querySelector('[data-cd-secs]');
    var endedText = timerEl.getAttribute('data-frytry-ended-text') || "Offer has ended";

    function tick() {
      var now = new Date().getTime();
      var diff = endTime - now;
      if (isNaN(endTime) || diff <= 0) {
        timerEl.innerHTML = '<span class="frytry-countdown-ended">' + endedText + '</span>';
        clearInterval(interval);
        return;
      }
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((diff % (1000 * 60)) / 1000);
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    var interval = setInterval(tick, 1000);
  });

  // ---- Quantity steppers (product page + cart page, works for multiple rows) ----
  var steppers = document.querySelectorAll('.frytry-qty-stepper');
  steppers.forEach(function (stepper) {
    var input = stepper.querySelector('.frytry-qty-input');
    var minusBtn = stepper.querySelector('[data-qty-minus]');
    var plusBtn = stepper.querySelector('[data-qty-plus]');
    var minVal = input ? parseInt(input.getAttribute('min'), 10) || 0 : 0;
    if (!input) return;
    if (minusBtn) minusBtn.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || minVal;
      if (v > minVal) input.value = v - 1;
    });
    if (plusBtn) plusBtn.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || minVal;
      input.value = v + 1;
    });
  });

  // ---- Product page: sticky add-to-cart bar ----
  var mainAddCart = document.getElementById('frytry-main-addcart');
  var stickyBar = document.getElementById('frytry-sticky-bar');
  var stickyAddCart = document.getElementById('frytry-sticky-addcart');
  if (mainAddCart && stickyBar && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-active');
        } else {
          stickyBar.classList.add('is-active');
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAddCart);

    if (stickyAddCart) {
      stickyAddCart.addEventListener('click', function () {
        mainAddCart.click();
      });
    }
  }

});
